module.exports = {
    SHOW_PRICES_IN_POINTS_STORAGE_KEY: '_show_prices_in_points',
};
